import { schemas } from '#oaf_schema.registry';
import { APPLICATION_TYPES } from 'appx/installationLinks';
import { getUniqueIteratorKey } from '~/modules/utilities/browserUtilities';
import { throwDevelopmentOrLog } from '~/modules/utilities/errorUtilities';
import { selectTestEnviroments } from './securityReviewStoreSelectors';
export let APP_PLATFORM_TYPE = /*#__PURE__*/function (APP_PLATFORM_TYPE) {
  APP_PLATFORM_TYPE["ios"] = "iOS";
  APP_PLATFORM_TYPE["android"] = "Android";
  APP_PLATFORM_TYPE["other"] = "Other";
  return APP_PLATFORM_TYPE;
}({});
export let AUTH_TYPE_SF_ORG = /*#__PURE__*/function (AUTH_TYPE_SF_ORG) {
  AUTH_TYPE_SF_ORG["salesforce"] = "Salesforce";
  AUTH_TYPE_SF_ORG["other"] = "Other";
  return AUTH_TYPE_SF_ORG;
}({});
export let AUTH_TYPE_API = /*#__PURE__*/function (AUTH_TYPE_API) {
  AUTH_TYPE_API["api"] = "API";
  AUTH_TYPE_API["oauth"] = "OAuth";
  AUTH_TYPE_API["saml"] = "SAML";
  return AUTH_TYPE_API;
}({});
export const getDefaultSFOrgItem = () => ({
  password: '',
  authType: AUTH_TYPE_SF_ORG.salesforce,
  username: '',
  token: '',
  loginUrl: '',
  description: '',
  deleted: false,
  iteratorKey: getUniqueIteratorKey()
});
export const getDefaultApiAuthItem = () => ({
  authType: AUTH_TYPE_API.api,
  apiKey: '',
  loginUrl: '',
  description: '',
  deleted: false,
  iteratorKey: getUniqueIteratorKey()
});
export const getDefaultMobileAppItem = () => schemas['securityReview/plugins/TestEnvironments/MobileAppItem'].new({
  iteratorKey: getUniqueIteratorKey(),
  description: ''
});
export const getDefaultClientAppItem = () => schemas['securityReview/plugins/TestEnvironments/ClientAppItem'].new({
  iteratorKey: getUniqueIteratorKey()
});
const selectors = {
  selectSalesforceOrgItems(state, isDraftState) {
    var _selectTestEnviroment;
    return (_selectTestEnviroment = selectTestEnviroments(state, isDraftState).salesforceOrgs) !== null && _selectTestEnviroment !== void 0 ? _selectTestEnviroment : [];
  },
  selectWebAppItems(state, isDraftState) {
    var _selectTestEnviroment2;
    return (_selectTestEnviroment2 = selectTestEnviroments(state, isDraftState).webAppAndServices) !== null && _selectTestEnviroment2 !== void 0 ? _selectTestEnviroment2 : [];
  },
  selectMobileInstallationLinks(state, isDraftState) {
    var _selectTestEnviroment3, _selectTestEnviroment4;
    return (_selectTestEnviroment3 = (_selectTestEnviroment4 = selectTestEnviroments(state, isDraftState).mobileApps) === null || _selectTestEnviroment4 === void 0 ? void 0 : _selectTestEnviroment4.installationLinks) !== null && _selectTestEnviroment3 !== void 0 ? _selectTestEnviroment3 : [];
  },
  selectMobileApplications(state, isDraftState) {
    var _selectTestEnviroment5, _selectTestEnviroment6;
    return (_selectTestEnviroment5 = (_selectTestEnviroment6 = selectTestEnviroments(state, isDraftState).mobileApps) === null || _selectTestEnviroment6 === void 0 ? void 0 : _selectTestEnviroment6.applications) !== null && _selectTestEnviroment5 !== void 0 ? _selectTestEnviroment5 : [];
  },
  selectClientAppItems(state, isDraftState) {
    var _selectTestEnviroment7;
    return (_selectTestEnviroment7 = selectTestEnviroments(state, isDraftState).clientApps) !== null && _selectTestEnviroment7 !== void 0 ? _selectTestEnviroment7 : [];
  },
  selectOtherInfo(state) {
    return selectTestEnviroments(state).otherInfo;
  }
};
export const {
  selectClientAppItems,
  selectMobileApplications,
  selectMobileInstallationLinks,
  selectOtherInfo,
  selectSalesforceOrgItems,
  selectWebAppItems
} = selectors;
export default function actions(set) {
  return {
    addSalesforceOrgItems(item = getDefaultSFOrgItem()) {
      set(function addSalesforceOrgItems(draft) {
        const salesforceOrgItems = selectSalesforceOrgItems(draft, true);
        salesforceOrgItems.push(item);
      });
    },
    editSalesforceOrgItems(item = getDefaultSFOrgItem()) {
      set(function addSalesforceOrgItems(draft) {
        const salesforceOrgItems = selectSalesforceOrgItems(draft, true);
        const index = salesforceOrgItems.findIndex(storeItem => storeItem.iteratorKey === item.iteratorKey);
        if (index !== -1) {
          salesforceOrgItems[index] = item;
        }
      });
    },
    removeSalesforceOrgItem(id) {
      set(function removeSalesforceOrgItem(draft) {
        var _salesforceOrgItems$i;
        const salesforceOrgItems = selectSalesforceOrgItems(draft, true);
        if (!salesforceOrgItems) {
          return;
        }
        const index = salesforceOrgItems.findIndex(item => item.iteratorKey === id);
        if ((_salesforceOrgItems$i = salesforceOrgItems[index]) !== null && _salesforceOrgItems$i !== void 0 && _salesforceOrgItems$i.id) {
          salesforceOrgItems[index].deleted = true;
        } else {
          salesforceOrgItems.pop();
        }
      });
    },
    addWebAppItems(item = getDefaultApiAuthItem()) {
      set(function addWebAppItems(draft) {
        const webAppItems = selectWebAppItems(draft, true);
        // Always append new items to the end of the list
        webAppItems.push(item);
      });
    },
    editWebAppItems(item = getDefaultApiAuthItem()) {
      set(function editWebAppItems(draft) {
        const webAppItems = selectWebAppItems(draft, true);
        const index = webAppItems.findIndex(storeItem => storeItem.iteratorKey === item.iteratorKey);
        if (index !== -1) {
          webAppItems[index] = item;
        }
      });
    },
    removeWebAppItem(id) {
      set(function removeWebAppItem(draft) {
        var _webAppItems$index;
        const webAppItems = selectWebAppItems(draft, true);
        if (!webAppItems) {
          return;
        }
        const index = webAppItems.findIndex(item => item.iteratorKey === id);
        if ((_webAppItems$index = webAppItems[index]) !== null && _webAppItems$index !== void 0 && _webAppItems$index.id) {
          webAppItems[index].deleted = true;
        } else {
          webAppItems.pop();
        }
      });
    },
    addMobileAppItem(item = getDefaultMobileAppItem()) {
      set(function addMobileAppItem(draft) {
        const mobileAppItems = selectMobileApplications(draft, true);
        mobileAppItems.push(item);
      });
    },
    editMobileAppItem(item, index) {
      set(function editMobileAppItem(draft) {
        const mobileAppItems = selectMobileApplications(draft, true);
        if (!mobileAppItems[index]) {
          throwDevelopmentOrLog(new Error(`Failed to find Mobile App Item item at index '${index}'`));
          return;
        }
        mobileAppItems[index] = {
          ...mobileAppItems[index],
          ...item
        };
      });
    },
    removeMobileAppItem(index) {
      set(function removeMobileAppItem(draft) {
        const mobileAppItems = selectMobileApplications(draft, true);
        if (mobileAppItems) {
          mobileAppItems.splice(index, 1);
        }
      });
    },
    addApplicationsLinks(applicationType) {
      set(function addApplicationsLinks(draft) {
        if (applicationType === APPLICATION_TYPES.clientApplications) {
          const applicationItems = selectClientAppItems(draft, true);
          applicationItems.push(schemas['securityReview/plugins/TestEnvironments/ClientAppItem'].new());
        } else {
          const applicationItems = selectMobileInstallationLinks(draft, true);
          applicationItems.push(schemas['securityReview/plugins/TestEnvironments/ClientAppItem'].new());
        }
      });
    },
    editApplicationsLinks(applicationType, item, index) {
      set(function editApplicationsLinks(draft) {
        const applicationItems = applicationType === APPLICATION_TYPES.clientApplications ? selectClientAppItems(draft, true) : selectMobileInstallationLinks(draft, true);
        if (applicationItems) {
          applicationItems[index] = item;
        }
      });
    },
    removeApplicationsLinks(applicationType, index) {
      set(function removeApplicationsLinks(draft) {
        const applicationItems = applicationType === APPLICATION_TYPES.clientApplications ? selectClientAppItems(draft, true) : selectMobileInstallationLinks(draft, true);
        if (applicationItems) {
          applicationItems.splice(index, 1);
        }
      });
    },
    setOtherInfo(otherInfo) {
      set(function setOtherInfo(draft) {
        selectTestEnviroments(draft, true).otherInfo = otherInfo;
      });
    }
  };
}